export const ExistingProfiles = 'existingProfiles'
export const LastUsedProfile = 'lastUsedProfile'
export const LastUsedVersion = 'lastUsedVersion'
export const LastUsedLanguage = 'lastUsedLanguage'
